<template>
  <button 
    :aria-label="name" 
    :disabled="disabled" 
    @click="onClick" 
    @touchstart="addActiveClass" 
    @touchcancel="removeActiveClass" 
    :class="['btn-container', { 'btn-active': isActive }]">
    <SvgIcon v-if="icon && useIcon" width="14.05rem" :name="icon" />
    <span>{{ name }}</span>
  </button>
</template>

<script>
import SvgIcon from "@/components/global/SvgIcon.vue";
export default {
  name: "IconButton",
  components: {
    SvgIcon,
  },
  props: {
    icon: {
      type: String,
      default: "",
    },
    useIcon: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    onClick(event) {
      event.stopPropagation();
      if (!this.disabled) {
        this.$emit("buttonClicked");
      }
    },
    addActiveClass() {
      this.isActive = true;
    },
    removeActiveClass() {
      this.isActive = false;
    },
  },
};
</script>

<style scoped>
.btn-container {
  padding: 3.5rem 7rem;
  font-size: 3rem;
  width: 33.875rem;
  font-weight: bold;
  border: none;
  border-radius: var(--border-radius-xl);
  cursor: pointer;
  background-color: var(--primary-white);
  box-shadow: var(--box-shadow-large) !important;
  border: 0.125rem solid var(--grey-outline);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 5rem;
}

.btn-container.btn-active {
  border: 0.125rem solid var(--brand-color);
  color: var(--brand-color);
  fill: var(--brand-color) !important;
  background-color: var(--primary-color-transparent);
}

.btn-container:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
</style>
